module.exports = __webpack_public_path__ + "assets/tenbisCredit-96a3df.svg";